import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { FilterTable, ContentSectionBlock, Card } from 'camino-react'

import { cloudhelpPatch } from '../../utilities/CloudHelp'

const LevelCell = ({ workflow }) => {
  const {
    status,
    updateStatus,
    loading,
    id
  } = workflow

  if (loading) {
    return 'Loading...'
  }

  return (
    <div>
      <label htmlFor={`status_toggle_for_workflow-${id}`}>
        <input
          type="checkbox"
          id={`status_toggle_for_workflow-${id}`}
          onChange={() => (updateStatus())}
          checked={status === 'Active'}
          value={status === 'Active'}
          name="status"
        />
        <span />
      </label>
    </div>
  )
}

LevelCell.propTypes = {
  workflow: PropTypes.arrayOf(PropTypes.object).isRequired
}

class WorkflowsTable extends React.Component {
  constructor (props) {
    super(props)
    const { workflows, alertWorkflows } = props

    this.state = {
      workflows,
      alertWorkflows
    }
  }

  updateStatus = (index) => {
    this.setStatusToLoading(index)
    const { workflows } = this.state
    const { status_toggle_url: statusToggleUrl } = workflows[index]

    cloudhelpPatch(statusToggleUrl)
      .then((response) => {
        const { data } = response
        this.setState((prevState) => {
          const { workflows: workflowsFromPrevState } = prevState
          const newWorkflows = _.map(workflowsFromPrevState, (workflow, workflowIndex) => (
            index === workflowIndex ? ({ ...data, loading: false }) : workflow))
          return { workflows: newWorkflows }
        })
      })
      .catch(() => {
        this.setState((prevState) => {
          const { workflows: workflowsFromPrevState } = prevState
          const newWorkflows = _.map(workflowsFromPrevState, (workflow, workflowIndex) => (
            index === workflowIndex ? ({ ...workflow, loading: false }) : workflow))
          return { workflows: newWorkflows }
        })
      })
  }

  setStatusToLoading = (index) => {
    this.setState((prevState) => {
      const { workflows } = prevState
      const newWorkflows = _.map(workflows, (workflow, workflowIndex) => (
        index === workflowIndex ? ({ ...workflow, loading: true }) : workflow))
      return { workflows: newWorkflows }
    })
  }

  attachHandlers = (workflows) => {
    const { updateStatus } = this
    return _.map(workflows, (workflow, index) => ({
      ...workflow,
      updateStatus: () => updateStatus(index)
    }))
  }

  render () {
    const { attachHandlers } = this
    const { workflows, alertWorkflows } = this.state
    const columns = [
      { text: 'ID', accessor: 'id', maxWidth: '100' },
      { text: 'Title', accessor: 'title' },
      { text: 'Description', accessor: 'description' },
      { text: 'Status', accessor: 'status' },
      {
        text: 'Activate',
        accessor: 'status_toggle_url',
        className: 'rt-td--no-link',
        Cell: row => (<LevelCell workflow={row.original} />)
      }
    ]
    const ticketsData = attachHandlers(workflows)
    const alertsData = attachHandlers(alertWorkflows)

    return (
      <div>
        <Card padding="xsmall">
          <ContentSectionBlock title="Tickets">
            <FilterTable
              columns={columns}
              data={ticketsData}
              noDataText="You currently have no ticket workflows"
              localStoragePrefix="WorkflowsTicketsTable"
            />
          </ContentSectionBlock>
        </Card>

        <Card padding="xsmall">
          <ContentSectionBlock title="Alerts">
            <FilterTable
              columns={columns}
              data={alertsData}
              noDataText="You currently have no alerts workflows"
              localStoragePrefix="WorkflowsAlertsTable"
            />
          </ContentSectionBlock>
        </Card>
      </div>
    )
  }
}

WorkflowsTable.propTypes = {
  workflows: PropTypes.arrayOf(PropTypes.object).isRequired
}

export default WorkflowsTable
